export default {
  dashboardTransactionRoles: '/dashboard/transaction/role',
  dashboardTransactionTaskCategories: '/dashboard/transaction/taskCategories',
};
